import React, { useState, useEffect } from 'react';
import { UserDataStore } from '../store/userDataStore';
import { NavLink } from "react-router-dom";
import { User } from '../models/user';
import { AboutInformation } from '../models/about-information';
import AboutDma from './AboutDma';
import QuickLaunch from './QuickLaunch';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { DmaAppConstants } from '../store/application-defaults';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
//import AuRUMIcon from '../svg/AuRUM-icon.svg';

export interface Props {
    children?: React.ReactNode;
}

let key = 0;

const DEVELOPMENT = "development";
const PILOT = "pilot";
const PRODUCTION = "production";

export default function Layout(props: Props) {
    const [isLoadingUser, setIsLoadingUser] =
        useState(true);

    const [currentUser, setCurrentUser] =
        useState<User | null>(null);

    const [showQuickSearchDialog, setShowQuickSearchDialog] =
        useState<boolean>();

    const [aboutDialogVisible, setAboutDialogVisible] =
        useState<boolean>();

    const [aboutInformation, setAboutInformation] =
        useState<AboutInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    //may be needed, leave
    const [serverVersion, setServerVersion] =
        useState<string>();

    const [serverMessage, setServerMessage] =
        useState<any>();

    useEffect(() => {
        getAllData();

        /* Leave this - it is part of eventual messaging system
        const eventSource = new EventSource("common/dmaservermessage");

        eventSource.onmessage = (event: any) => {
            try {
                setServerMessage(event.data);

                console.log("EVENT SOURCE MESSAGE");
                console.log(event);

            } catch (e) {
                console.log("ERR");
                console.log(e);
            }
        }

        return () => {
            eventSource.close(); // Clean up on unmount or dependency change
        };
        */

    }, []);

    useEffect(() => {
        showNonProductionWarning();
    }, [aboutInformation]);

    useEffect(() => {

    });

    key++;

    let environmentTypeCss = "environment-type";

    if (aboutInformation && aboutInformation.environmentType) {
        if (aboutInformation.environmentType.toLowerCase() === DEVELOPMENT)
            environmentTypeCss = `${environmentTypeCss} pw-red`;
        else if (aboutInformation.environmentType.toLowerCase() === PILOT)
            environmentTypeCss = `${environmentTypeCss} pw-orange`;
        else if (aboutInformation.environmentType.toLowerCase() === PRODUCTION)
            environmentTypeCss = `${environmentTypeCss} pw-light-green`;
    }

    const isSA = currentUser && currentUser.roleCodes &&
        currentUser.roleCodes.includes('SA');

    if (isLoadingUser) {
        return (
            <div>
                <LoadIndicator height={30} width={30} />
                <p>Loading your account. This may take a minute...</p>
            </div>
        );
    }

    if (!currentUser) {
        return (
            <div>
                <h3>Could not load user profile</h3>
                <p>If this is your first visit today, the database might still be starting. Please wait a moment and refresh.</p>
                <button onClick={() => window.location.reload()}>Try Again</button>
            </div>
        );
    }

    return (
        <React.Fragment>
            {currentUser && (
                <>
                    <div id="header">
                        <div className="white-aurum-logo-container">
                            <div className="white-aurum-logo"></div>
                        </div>

                        <div id="header-title">
                            <div id="header-title-text">{DmaAppConstants.name}</div>
                        </div>

                        {aboutInformation && aboutInformation.environmentType &&
                            <div>
                                <div id="environment-type-text" className={environmentTypeCss}>{aboutInformation ? aboutInformation.environmentType : ''}</div>
                            </div>
                        }

                        <div>{serverMessage}</div>

                        <div id="header-right">
                            <span className="material-symbols-outlined nav-bar-icon pw-gray-200 cursor-pointer pw-margin-right-1"
                                onClick={showQuickLaunchDialog}>search</span>
                            <span className="material-symbols-outlined nav-bar-icon pw-pink cursor-pointer">3p</span>
                            <span className="material-symbols-outlined nav-bar-icon pw-light-green cursor-pointer">calendar_clock</span>
                            <div id="header-user"><span id="header-name">{currentUser ? currentUser.userName : ''}</span></div>
                            <Button icon="preferences" onClick={showAboutDialog} />
                        </div>
                    </div>

                    <div id="shell">
                        <div id="pw-navbar">
                            <NavLink id="home-nav-link" className="pw-side-link" to="/">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">home</span>
                                    </div>
                                    <span className="pw-side-link-text">Home</span>
                                </div>
                            </NavLink>

                            <NavLink id="products-nav-link" className="pw-side-link" to="/products">
                                <div className="pw-side-nav-item" >
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">architecture</span>
                                    </div>
                                    <span className="pw-side-link-text">Product Planning</span>
                                </div>
                            </NavLink>

                            <NavLink id="assets-nav-link" className="pw-side-link" to="/assets-launcher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">adf_scanner</span>
                                    </div>
                                    <span className="pw-side-link-text">Assets</span>
                                </div>
                            </NavLink>

                            <NavLink id="bench-sheet-nav-link" className="pw-side-link" to="/benchsheetlauncher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">dynamic_form</span>
                                    </div>
                                    <span className="pw-side-link-text">QC Bench Sheets</span>
                                </div>
                            </NavLink>

                            <NavLink id="assets-nav-link" className="pw-side-link" to="/methods">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">note_alt</span>
                                    </div>
                                    <span className="pw-side-link-text">Methods</span>
                                </div>
                            </NavLink>

                            <NavLink id="standards-nav-link" className="pw-side-link" to="/standards-launcher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">fact_check</span>
                                    </div>
                                    <span className="pw-side-link-text">Standards</span>
                                </div>
                            </NavLink>

                            <NavLink id="standards-nav-link" className="pw-side-link" to="/calculator-launcher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">calculate</span>
                                    </div>
                                    <span className="pw-side-link-text">Calculators</span>
                                </div>
                            </NavLink>

                            {/*<NavLink id="standards-nav-link" className="pw-side-link" to="/cofalauncher">*/}
                            {/*    <div className="pw-side-nav-item">*/}
                            {/*        <div className="pw-nav-item-image">*/}
                            {/*            <span className="material-symbols-outlined nav-bar-icon">summarize</span>*/}
                            {/*        </div>*/}
                            {/*        <span className="pw-side-link-text">Certificates</span>*/}
                            {/*    </div>*/}
                            {/*</NavLink>*/}

                            <NavLink id="standards-nav-link" className="pw-side-link" to="/events-launcher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">calendar_clock</span>
                                    </div>
                                    <span className="pw-side-link-text">Events</span>
                                </div>
                            </NavLink>

                            <NavLink id="standards-nav-link" className="pw-side-link" to="/controlled-documents">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">edit_document</span>
                                    </div>
                                    <span className="pw-side-link-text">Documents</span>
                                </div>
                            </NavLink>

                            <NavLink id="report-designer-nav-link" className="pw-side-link" to="/report-designer">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">format_image_right</span>
                                    </div>
                                    <span className="pw-side-link-text">Report Designer</span>
                                </div>
                            </NavLink>

                            <NavLink id="standards-nav-link" className="pw-side-link" to="/resources">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">apps</span>
                                    </div>
                                    <span className="pw-side-link-text">Resources</span>
                                </div>
                            </NavLink>

                            {isSA &&
                                <NavLink id="administration-nav-link" className="pw-side-link" to="/administration">
                                    <div className="pw-side-nav-item">
                                        <div className="pw-nav-item-image">
                                            <span className="material-symbols-outlined nav-bar-icon">settings</span>
                                        </div>
                                        <span className="pw-side-link-text">Administration</span>
                                    </div>
                                </NavLink>
                            }

                            <NavLink id="access-data-nav-link" className="pw-side-link" to="/tickets">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">assignment_late</span>
                                    </div>
                                    <span className="pw-side-link-text">Ticket Log</span>
                                </div>
                            </NavLink>

                            <NavLink id="documentation-nav-link" className="pw-side-link" to="/documentationlauncher">
                                <div className="pw-side-nav-item">
                                    <div className="pw-nav-item-image">
                                        <span className="material-symbols-outlined nav-bar-icon">article</span>
                                    </div>
                                    <span className="pw-side-link-text">DMA Help Guide</span>
                                </div>
                            </NavLink>

                        </div>
                        <div className="main">
                            {props.children}
                        </div>
                    </div>


                    {showQuickSearchDialog &&
                        <DialogPopup visible={showQuickSearchDialog}
                            fullScreen={true}
                            onHiding={hideQuickLaunchDialog}
                            title="Quick Search Products and Batches" >
                            <QuickLaunch key={`S${key}`} onCancel={hideQuickLaunchDialog} />
                        </DialogPopup>
                    }

                    {aboutDialogVisible &&
                        <DialogPopup
                            visible={aboutDialogVisible}
                            onHiding={hideAboutDialog}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            title="About DMA"
                            width={500}
                            height={280}>
                            <AboutDma key={`AD${key}`} onOkClick={hideAboutDialog} userInfo={UserDataStore.getCurrentUser()} />
                        </DialogPopup>
                    }

                    {globalDialogVisible &&
                        <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
                    }
                </>
            )}
        </React.Fragment>
    );

    function showNonProductionWarning() {
        if (!aboutInformation)
            return;

        if (aboutInformation?.environmentType?.toLowerCase() === PILOT ||
            aboutInformation?.environmentType?.toLowerCase() === DEVELOPMENT) {
            showInformationMessageWithSize(ModalMessageType.Warning,
                "Non-Production Environment", "You are in a non-production environment. Any data saved here will not be part of the DMA Production database.",
                '50vw',
                '50vh');
        }
    }

    function showQuickLaunchDialog() {
        setShowQuickSearchDialog(true);
    }

    function hideQuickLaunchDialog() {
        setShowQuickSearchDialog(false);
    }

    function showAboutDialog() {
        setAboutDialogVisible(true);
    }

    function hideAboutDialog() {
        setAboutDialogVisible(false);
    }

    async function getUserInformation() {
        try {
            const data = await CrudFunctions.getData("users/getuserinfo");
            const user = data as User;
            UserDataStore.setCurrentUser(user);
            setCurrentUser(user);
        } catch (err) {
            showMessage(err, ModalMessageType.Error, "Error Retrieving User Information");
            setCurrentUser(null);
            UserDataStore.setCurrentUser(null);
        } finally {
            setIsLoadingUser(false);
        }
    }

    async function getDmaInformation() {
        await CrudFunctions.getData("common/dmainformation")
            .then((data) => {
                setAboutInformation(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving DMA Application Information");
            });
    }

    async function getServerVersion() {
        await CrudFunctions.getData("common/serverversion")
            .then((data) => {
                setServerVersion(data.value)
            })
    }

    async function getAllData() {
        try {
            await Promise.all([
                getUserInformation(),
                getDmaInformation(),
                getServerVersion()
            ])
        } catch (err) {
            console.error("Critical failure in getAllData: ", err);
            setIsLoadingUser(false);
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showInformationMessageWithSize(mode: ModalMessageType, title: string, message: string, width: string, height: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            width: width,
            height: height
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
